import React, { useState, useEffect } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  InputLabel,
  MenuItem,
  Select
} from '@mui/material';
import { t } from '../../../../utils/textUtils';
import { PROJECT_STATUS_OPTIONS } from '../utils/constants';

const StatusChangeDialog = ({ open, currentStatus, onClose, onSubmit }) => {
  const [newStatus, setNewStatus] = useState(currentStatus || 'planning');

  useEffect(() => {
    if (open) setNewStatus(currentStatus || 'planning');
  }, [open, currentStatus]);

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle sx={{ fontWeight: 'bold', color: '#5D4037' }}>
        {t('UBAH STATUS PROYEK')}
      </DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ mb: 2 }}>{t('PERBARUI STATUS PROYEK INI.')}</DialogContentText>
        <FormControl fullWidth>
          <InputLabel id="status-select-label">{t('STATUS')}</InputLabel>
          <Select
            labelId="status-select-label"
            value={newStatus}
            label="Status"
            onChange={(e) => setNewStatus(e.target.value)}
          >
            {PROJECT_STATUS_OPTIONS.map((opt) => (
              <MenuItem key={opt.value} value={opt.value}>
                {t(opt.labelKey)}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} sx={{ color: '#5D4037' }}>
          {t('BATAL')}
        </Button>
        <Button
          onClick={() => onSubmit(newStatus)}
          variant="contained"
          sx={{ bgcolor: '#F0C14B', '&:hover': { bgcolor: '#DDA726' }, color: '#5D4037' }}
        >
          {t('PERBARUI STATUS')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default StatusChangeDialog;
